import React, { FC } from 'react';
import styles from './recruiterLanding.module.less';
import { Title } from '../../../components/Typogrphy/Title';
import { Button, Carousel } from 'antd';
import Image from 'next/image';
import { PlusOutlined } from '@ant-design/icons';
import EmpBranding from '../../../public/recruiter/recruiter-landing/EmpBranding.svg';
import Rec_CanAnalytics from '../../../public/recruiter/recruiter-landing/Rec_CanAnalytics.svg';
import AppTracking from '../../../public/recruiter/recruiter-landing/AppTracking.svg';
import Referral_Scheme from '../../../public/recruiter/recruiter-landing/Referral_Scheme.svg';
import Eyeball from '../../../public/recruiter/recruiter-landing/Eyeball.svg';
import Recruiter_dashboard from '../../../public/recruiter/recruiter-landing/Recruiter_dashboard.svg';
import Collaborative_hiring from '../../../public/recruiter/recruiter-landing/Collaborative_hiring.svg';

// import RecruiterCreateModal, {
//   RecruiterCreateModalInstance,
// } from '../../Recruiiter/RecruiterCreateModal';
import { useRouter } from 'next/router';

export const RecruiterBenifitsBanner: FC = () => {
  // const ref = useRef<RecruiterCreateModalInstance>(null);
  const history = useRouter();
  return (
    <div className={styles.benifitscontainer}>
      <span className={styles.Heading}>
        Benefits of hiring with <span style={{ color: '#009E52' }}>Careers360 </span>
      </span>
      <div className={styles.benifitslistcont}>
        <div className={styles.container}>
          <div className={styles.box}>
            {' '}
            <div className={styles.innercontainer}>
              <div className={styles.icon}>
                <Image width={30} height={30} src={Rec_CanAnalytics} alt="Recruiter & Candidate" />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Recruiter & Candidate Analytics</div>
                <div className={styles.desc}>Track your recruitment performance</div>
              </div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image width={30} height={30} src={AppTracking} alt="Applicant Tracking" />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Applicant Tracking System (ATS)</div>
                <div className={styles.desc}>Effectively manage your talent acquisition</div>
              </div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image
                  width={30}
                  height={30}
                  src={Referral_Scheme}
                  alt="Gamified Referral Scheme"
                />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Gamified Referral Scheme</div>
                <div className={styles.desc}>Get your employees to refer good candidates</div>
              </div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image width={30} height={30} src={Eyeball} alt="Eyeball" />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Eyeball</div>
                <div className={styles.desc}>
                  Access our full job seeker database & headhunt successful hires
                </div>
              </div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image width={30} height={30} src={Recruiter_dashboard} alt="Recruiter dashboard" />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Recruiter dashboard</div>
                <div className={styles.desc}>Effectively manage your talent acquisition</div>
              </div>
            </div>
          </div>
          <div className={styles.box}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image
                  width={30}
                  height={30}
                  src={Collaborative_hiring}
                  alt="Collaborative hiring"
                />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Collaborative hiring</div>
                <div className={styles.desc}>
                  Add multiple users to same recruiter profile at no extra cost
                </div>
              </div>
            </div>
          </div>
          <div className={styles.box} style={{ margin: 'auto' }}>
            <div className={styles.innercontainer}>
              {' '}
              <div className={styles.icon}>
                <Image width={30} height={30} src={EmpBranding} alt="Placeholder Image" />
              </div>
              <div className={styles.text}>
                <div className={styles.title}>Employer Branding</div>
                <div className={styles.desc}>
                  Stand out from the crowd and capture the best talent
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* mobile benifits list carosel */}
      <div className={styles.CarouselMob} style={{ width: '100%', height: 'auto' }}>
        <Carousel dotPosition={'bottom'} style={{ width: '100%', height: 'auto' }}>
          <div>
            <div className={styles.benifitslistcontMob}>
              <div className={styles.container}>
                <div className={styles.box}>
                  {' '}
                  <div className={styles.innercontainer}>
                    <div className={styles.icon}>
                      <Image
                        width={30}
                        height={30}
                        src={Rec_CanAnalytics}
                        alt="Recruiter & Candidate"
                      />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Recruiter & Candidate Analytics</div>
                      <div className={styles.desc}>Track your recruitment performance</div>
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image width={30} height={30} src={AppTracking} alt="Applicant Tracking" />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Applicant Tracking System (ATS)</div>
                      <div className={styles.desc}>Effectively manage your talent acquisition</div>
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image
                        width={30}
                        height={30}
                        src={Referral_Scheme}
                        alt="Gamified Referral Scheme"
                      />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Gamified Referral Scheme</div>
                      <div className={styles.desc}>Get your employees to refer good candidates</div>
                    </div>
                  </div>
                </div>
                <div
                  className={styles.box}
                  style={{
                    marginBottom: '30px',
                  }}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image width={30} height={30} src={Eyeball} alt="Eyeball" />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Eyeball</div>
                      <div className={styles.desc}>
                        Access our full job seeker database & headhunt successful hires
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className={styles.benifitslistcontMob}>
              <div className={styles.container}>
                <div className={styles.box}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image
                        width={30}
                        height={30}
                        src={Recruiter_dashboard}
                        alt="Recruiter dashboard"
                      />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Recruiter dashboard</div>
                      <div className={styles.desc}>Effectively manage your talent acquisition</div>
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image
                        width={30}
                        height={30}
                        src={Collaborative_hiring}
                        alt="Collaborative hiring"
                      />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Collaborative hiring</div>
                      <div className={styles.desc}>
                        Add multiple users to same recruiter profile at no extra cost
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.box} style={{ margin: 'auto' }}>
                  <div className={styles.innercontainer}>
                    {' '}
                    <div className={styles.icon}>
                      <Image width={30} height={30} src={EmpBranding} alt="Placeholder Image" />
                    </div>
                    <div className={styles.text}>
                      <div className={styles.title}>Employer Branding</div>
                      <div className={styles.desc}>
                        Stand out from the crowd and capture the best talent
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};
